import VerifyOtpPage from "../../features/authentication/verify-otp-page/verify-otp-page";

export default function VerifyOtp() {
  return <VerifyOtpPage />;
}

VerifyOtp.displayName = "VerifyOtp";
